<template>
    <v-dialog width="900px" v-model="translateQDialog">
         <v-btn slot="activator" fab dark small color="blue" ><v-icon>translate</v-icon> 
        </v-btn>
        <v-card color="grey lighten-4" flat offset-md4 >
      <v-container grid-list-md pa-3>
            
            
        <v-layout row wrap>
          <v-flex xs11>
            <div style="color: purple; text-align:center; margin-top:2%"><h2>Translate Question </h2></div>
          </v-flex>
          <v-flex xs1 style="">
              <v-btn flat fab small @click="translateQDialog=false;"> <v-icon>close</v-icon></v-btn>
          </v-flex>
        <v-layout column wrap pa-3>
            <v-flex xs6 text-xs-center>
                <v-text-field
                 label="Language"
                :value="language"
                readonly>
                </v-text-field>
              
            </v-flex>
            <v-flex xs6>
                <v-text-field
                id="quest"
                name="quest"
                label="Question"
                :value="que.question"
                readonly
                >   
                </v-text-field>
                
            </v-flex>
           <v-flex xs12 v-for="(item, index) in que.options" :key="index">
              <v-layout row> 
               <v-text-field
               :label="`${index+1} answer`"
               :value="item"
            required
            readonly>  </v-text-field></v-layout>
          </v-flex>
          <v-flex xs12>
    <v-radio-group v-model="correct" disabled>
      <v-radio
        v-for="n in que.options.length"
        :key="n"
        :label="`Σωστή απάντηση ${n}`"
        :value="n"
      ></v-radio>
    </v-radio-group>
          </v-flex>

        </v-layout>
                  <v-layout column wrap pa-3>
            <v-flex xs6 >
               <v-select
               label="Translate in"
               :items="langs"
               v-model="langTobeTranslated">

               </v-select>
            </v-flex>
            <v-flex xs6>
                <v-text-field
                id="tit"
                name="question"
                label="Translate Question"
                v-model="translatedQuestion"
                 :disabled="avLang"
                >   
                </v-text-field>
                
            </v-flex>
           <v-flex xs12 v-for="(item, index) in que.options" :key="index">
              <v-layout row> 
               <v-text-field
               :label="`${index+1} answer`"
            v-model="translatedOptions[index]"
            required
             :disabled="avLang">  </v-text-field></v-layout>
          </v-flex>
          <v-flex xs12>
    <v-radio-group v-model="correct" disabled>
      <v-radio 
        v-for="n in que.options.length"
        :key="n"
        :label="`Σωστή απάντηση ${n}`"
        :value="n"
      ></v-radio>
    </v-radio-group>
          </v-flex>

        </v-layout>

      <div style="margin-left:44%;">
            <v-spacer></v-spacer>
          <v-btn @click="onSubmitChanges" color="red" style="color:white;" 
          :disabled="!formIsValid"
          > Translate Question </v-btn>
</div>
        </v-layout>
      </v-container>
    </v-card>
    </v-dialog>
 

</template>

<script>
export default {
 props: {que: Object, types: Array},
  data() {
    return {
        correct: this.que.correct,
      translateQDialog: false,
      langTobeTranslated: "",
      langType: [1, 2],
      translatedQuestion: "",
      translatedOptions:[],
      id: this.que.id
    };
  },
  computed: {
    language() {
      if (this.que.language === 1) {
        return "English";
      } else if (this.que.language === 2) {
        return "Greek";
      }
    },
    avLang(){
        if (this.langTobeTranslated ===""){
            return true;
        }else{
            return false;
        }
    },
    formIsValid() {
         if(this.translatedQuestion !=="" && this.translatedQuestion !== undefined){
      for (let index = 0; index < this.que.options.length; index++) {
          if(this.translatedOptions[index]=== "" || this.translatedOptions[index]===undefined){
              return false;
          }

      }
      return true;
      }
      return false;
    },
    langs() {
      var langTypes = [];
      for (let index = 0; index < this.types.length; index++) {
        if (
          this.que.school_type === this.types[index].sch &&
          this.que.id === this.types[index].id &&
          this.que.point === this.types[index].point
        ) {
          langTypes.push(this.types[index].lang);
        }
        for (let index = 0; index < langTypes.length; index++) {
          var i = this.langType.indexOf(langTypes[index]);
          if (i > -1) {
            this.langType.splice(i, 1);
          }
        }
      }
      var langNames=["English","Greek"];
    for (let index = 0; index < this.langType.length; index++) {
         this.langType[index] = langNames[this.langType[index]-1];
        
    }
      return this.langType;
    }
  },
  methods: {
    onSubmitChanges() {
      if (!this.formIsValid) {
        return;
      }
      if(this.langTobeTranslated === "Greek"){
          this.langTobeTranslated = 2;
      }else{
           this.langTobeTranslated = 1;
      }
      const queData = {
        question: this.translatedQuestion,
        options: this.translatedOptions,
        correct: this.correct,
        language:this.langTobeTranslated,
        id: this.que.id,
        school_type: this.que.school_type,
        theme: this.que.point,
        key: this.que.key,
        createdBy: this.$store.getters.user.email
      };
      this.$store.dispatch("translateQue", queData);
      this.$store.dispatch("loadSpotContent", this.que.point);
      this.translateQDialog = false;

    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/edit-questions/translate-question.vue